import $ from 'jquery';
import BasketService from '../service/BasketService';
import StoreService from '../service/StoreService';
import SelectService from '../service/SelectService';
import Cookie from '../util/Cookie';
import GiftService from "../service/GiftService";
import AnimateNumber from "../service/AnimateNumber";
import numeral from 'numeral';

let debounceChange,
    debounceDelete;
$('.quantity__value').mask('000');

$('.quantity__button--minus').click(function () {
    const value = $(this).parents('.quantity').find('.quantity__value');
    let val = +value.val() - 1;

    if (val < 1) {
        val = 1;
    }
    value.val(val).change();

    GiftService.htmlGiftItemMinus($(this));
    GiftService.htmlGiftBxRender();
});

$('.quantity__button--plus').click(function () {
    const value = $(this).parents('.quantity').find('.quantity__value');
    let val = +value.val() + 1;

    if (val > 999) {
        val = 999;
    }
    value.val(val).change();

    GiftService.htmlGiftItemPlus($(this));
    GiftService.htmlGiftBxRender();
});

$('.quantity__value').blur(function () {
    const val = $(this).val();
    if (val == '' || !val || val == 0) {
        $(this).val('1').change();
    }
});

$('.quantity__value').change(function () {
    clearTimeout(debounceChange);
    const basketItemId = $(this).parents('.cart-item').attr('data-basket-item-id');
    GiftService.render();

    debounceChange = setTimeout(() => {
        BasketService.update(basketItemId, $(this).val())
            .then((response) => {
                $('.header-cart__quantity').text(response.count);
                $('.header-cart__quantity').addClass('header-cart__quantity--added');
                setTimeout(() => {
                    $('.header-cart__quantity').removeClass('header-cart__quantity--added');
                }, 300);

                GiftService.printPoints(basketItemId, 'ID').then((response) => {
                    AnimateNumber.animate({
                        numb_start: $(this).parents('.cart-item').attr('data-points'),
                        number_end: response.points,
                        executeElement: $('#cart-item__points-' + basketItemId),
                        hint: 'Points: ',
                        calculate: (val)=>{return numeral(val).format('0[.]0[0]')}
                    });

                    AnimateNumber.animate({
                        numb_start: $(this).parents('.cart-item').attr('data-points'),
                        number_end: response.totalpoints,
                        executeElement: $('#cart-item__total-points-' + basketItemId),
                        hint: 'Points: ',
                        calculate: (val)=>{return numeral(val).format('0[.]0[0]')}
                    });

                    $(this).parents('.cart-item').attr('data-points', response.points);

                    let pointsOverall = 0;
                    $('.cart-item').each(function () {
                        const points = $(this).attr('data-points');
                        const isGift = $(this).attr('data-is-gift');
                        const quantity = +$(this).find('.quantity__value').val();

                        if(isGift == "Y") {
                            console.log(points, 'points');
                            console.log(quantity, 'quantity');
                            pointsOverall += (points * quantity) - points;
                            console.log(pointsOverall, 'gift');
                        } else {
                            pointsOverall += points * quantity;
                        }
                    });
                    $('.cart-result__points').html(numeral(pointsOverall).format('0[.]0[0]'));
                });
                BasketService.render();
            });
    }, 300);
});

$('.cart-item__delete').click(function () {
    clearTimeout(debounceDelete);
    debounceDelete = setTimeout(() => {
        const productName = $(this).parents('.cart-item')
            .find('.cart-item__title')
            .text()
            .trim();
        if (window.confirm(`Are you sure you want to remove the item "${productName}" from the cart?`)) {
            BasketService.update($(this).parents('.cart-item').attr('data-basket-item-id'), 0)
                .then((response) => {
                    $('.header-cart__quantity').text(response.count);
                    $('.header-cart__quantity').addClass('header-cart__quantity--added');
                    setTimeout(() => {
                        $('.header-cart__quantity').removeClass('header-cart__quantity--added');
                    }, 300);
                });
            $(this).parents('.cart-item').remove();
            BasketService.render();
            GiftService.render();
        }
    }, 300);
});

$('.cart-result__add-more').on('click', function () {
    Cookie.set('back_to_basket', 1, false);
});

StoreService.onChange(() => {
    BasketService.get().then((response) => {
        response.items.forEach((item) => {
            $(`.cart-item--${item.id}`)
                .attr('data-price', item.price)
                .attr('data-points', item.points);

            BasketService.render();
        });
    });
});

SelectService.onChange('basket-store', (value) => {
    $(`.city-selection-item[data-id="${value}"]`).click();
});

$(document).ready(function(){
    GiftService.render();
})